// import subVisual from "@/assets/images/user/subVisual.jpg";
// import subVisualTb from "@/assets/images/user/subVisualTb.jpg";
// import subVisualTxt from "@/assets/images/user/subVisualTxt.png";
// import subVisualTxtTb from "@/assets/images/user/subVisualTxtTb.png";

// 이전 서브 비주얼(2차) - 삭제하지 말고 재사용 대비 보존
// import subVisual from "@/assets/images/user/subVisual-2.jpg";
// import subVisualTb from "@/assets/images/user/subVisualTb-2.png";

import subVisual from "@/assets/images/user/subVisual-3.jpg";
import subVisualTb from "@/assets/images/user/subVisualTb-3.jpg";

export default function SubVisual() {
    return (
        <>
            {/* <div className="relative h-[240px] md:h-[480px]">
            <img src={subVisual} alt="배경이미지" className="w-full h-full object-cover hidden lg:block" />
            <img src={subVisualTb} alt="배경이미지" className="w-full h-full object-cover lg:hidden" />
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-[calc(-50%+40px)] h-[80px] md:h-[179px]">
                <img src={subVisualTxt} alt="GXG2025" className="max-h-full hidden lg:block" />
                <img src={subVisualTxtTb} alt="GXG2025" className="max-h-full lg:hidden" />
            </div>
        </div> */}
            <div className="relative ">
                <img src={subVisual} alt="GXG 2026 - 게임, 문화로 즐기다!" className="hidden w-full lg:block" />
                <img src={subVisualTb} alt="GXG 2026 - 게임, 문화로 즐기다!" className="w-full lg:hidden" />
            </div>
        </>
    );
}
